import type { MutableRefObject } from "react";
import { useEffect, useRef } from "react";

type UseTrustPilotWidgetReturnType = {
  trustPilotContainerRef: MutableRefObject<HTMLDivElement | null>;
};

export const useTrustPilotWidget = (): UseTrustPilotWidgetReturnType => {
  const trustPilotContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (window.Trustpilot && trustPilotContainerRef.current) {
      window.Trustpilot.loadFromElement(trustPilotContainerRef.current, false);
    }
  }, []);

  return {
    trustPilotContainerRef
  };
};
